import { FieldError } from "client/lib/apt-merchant";

import { Field } from "../../field";
import { Merchant } from "../../merchant";
import { MerchantField } from "../../types";
import { maxLength, minLength } from "../../validate";

export class StockMarketListerField extends Field<string> {
  constructor(model: Merchant, opts: Partial<MerchantField<string>> = {}) {
    super(model, {
      dataType: "string",
      propertyName: "stockMarketLister",
      uiFieldType: "Input",
      testValue: "SQ",
      ...opts,
    });
  }

  get applicable(): boolean {
    const registeredCountry = this._model.companyInformation.registeredCountry
      .value;
    const businessType = this._model.companyInformation.businessType.value;

    return (
      registeredCountry === "New Zealand" && businessType === "Public Company"
    );
  }

  get required(): boolean {
    return this.applicable;
  }

  get shown(): boolean {
    return this.applicable;
  }

  _validate(): void {
    if (typeof this.value === "undefined") return;

    // Must be between 1 -5 characters
    if (!minLength(1)(this.value)) {
      throw new FieldError(this, "Min length 1", "InvalidLength");
    }
    if (!maxLength(5)(this.value)) {
      throw new FieldError(this, "Max length 5", "InvalidLength");
    }
  }
}
